import { fetcher } from "utils";

import { GetUserablesProductsRecentResponse } from "typings";

export const get__userables__products__recent = (): Promise<GetUserablesProductsRecentResponse> =>
  fetcher.get("/userables/products/recent");
